import { gql } from '@apollo/client';
import { OTK_PROJ_UUID } from 'app-constants';
import { LoadOptions } from 'devextreme/data';

import { CustomStoreExt } from 'types/datatypes/classes';
import { ILab } from 'types/datatypes/ILab';
import { INom } from 'types/datatypes/INom';
import { TDoc_types } from 'types/IOptions';
import { createDataSource } from 'utils/gql-datasource';
const dsGetNoms = gql(`query dsGetNoms($ref: String, $limit: Int, $offset: Int, $jfilt: [JSON]) {
  totalcount: noms(ref: $ref, totalCount: 1) { totalcount }
  list: noms(ref: $ref, limit: $limit, offset: $offset, jfilt: $jfilt ) {
    ref 
    name 
    name_full 
    vat_rate
    article
    doc_type
  }
}`);

export const dsNoms = createDataSource<INom>(dsGetNoms);

export const dsProjNoms = <T=INom>(
  projRef:string,
  lab:ILab,
  doc_type:TDoc_types|null = null
  ): CustomStoreExt<T, any> => {

  const services = lab?.services?.map((row) => row.nom) ?? [];
  const dsProxy = Object.create(dsNoms);
  const projFilter = [ [ 'proj', '=', projRef ?? OTK_PROJ_UUID ], 'and', [ 'nom_kind', '=', '73226695-fb5d-11e7-8d07-309c23427d96' ] ];
  dsProxy.load = (options: LoadOptions<INom>) => dsNoms.load({ ...options, filter: projFilter })
    .then((rows: any) => {
      if (services?.length) {
        const filtered = rows?.data?.filter((row:any) => services.includes(row.ref));
        if (filtered.length) rows.data = filtered;
      }
      rows = rows?.data?.filter((row:any) => row?.doc_type === doc_type);
      return rows;
    });
  return dsProxy;
};

export const dsProjGoods = <T=INom>(
  projRef:string,
  lab:ILab,
  doc_type:TDoc_types|null = null
  ): CustomStoreExt<T, any> => {

  const goods = lab?.goods?.map((row) => row.nom) ?? [];
  const dsProxy = Object.create(dsNoms);
  const projFilter = [ [ 'proj', '=', projRef ?? OTK_PROJ_UUID ], 'and', [ 'nom_kind', '=', '6ea7f5b1-8e2d-11ec-8ad6-00155d000b0b' ] ];
 //товар
  dsProxy.load = (options: LoadOptions<INom>) => dsNoms.load({ ...options, filter: projFilter })
    .then((rows: any) => {
      if (goods?.length) {
        const filtered = rows?.data?.filter((row:any) => goods.includes(row.ref));
        if (filtered.length) rows.data = filtered;
      }
      rows = rows?.data?.filter((row:any) => row?.doc_type === doc_type);
      return rows;
    });
  return dsProxy;
};
